import React from 'react';
import './PersonalDetail.css'
import personalImg from '../../images/prity-black.jpeg';
import { faGithub} from '@fortawesome/free-brands-svg-icons';
import {  Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMinus } from '@fortawesome/free-solid-svg-icons';
import { faLinkedinIn, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { Image } from 'react-bootstrap';



const PersonalDetail = () => {
    return (
        <div  >
            <div data-aos="zoom-in-up"
        data-aos-easing="ease-out-cubic"
        data-aos-duration="1000" className='right-top'>
              
                <div className='border1'></div>
                <div className='border2'></div>
                <div  className="img-holder">
                <Image src={personalImg}  rounded fluid />
                    {/* <img src={personalImg} alt="" srcset="" /> */}
                    <Box sx={{my: 4}}>

                        <Typography variant="h5" sx={{fontFamily:'Montserrat',fontWeight:'500'}}>
                            SOMIYA KHAN PRITY
                        </Typography>
                        <Typography variant="p" sx={{fontFamily:'Montserrat',color:'rgb(90, 89, 89)'}}>
                            Jr. Frontend Developer
                        </Typography>
                    </Box>
                </div>
            </div>
            <div  style={{width:'200px',margin:'0 auto'}}>
            <Box sx={{marginTop:'50px' , marginBottom:'100px'}}>
                <Box sx={{textAlign:'center'}}>
                    
                        <Typography className='available-icon' variant='h5'>I'm available on <FontAwesomeIcon icon={faMinus}></FontAwesomeIcon></Typography>
                        
   
                    <Box className='contact-icon' sx={{mt:1}}>
                        <ul>
                            <li><a  rel='noreferrer' target="_blank"   href="https://www.linkedin.com/in/somiya-khan-prity-86043a1a8/"><FontAwesomeIcon icon={faLinkedinIn} ></FontAwesomeIcon> </a></li>
                            <li> <a target="_blank" rel='noreferrer' href="https://github.com/somiyaPrity"><FontAwesomeIcon icon={faGithub}></FontAwesomeIcon></a></li>
                            <li>  <a  target="_blank" rel='noreferrer'  href="mailto:somiyakhanp32@gmail.com"><FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon> </a></li>
                            <li><a  target="_blank" rel='noreferrer'  href="https://wa.me/8801888769788"><FontAwesomeIcon icon={faWhatsapp}></FontAwesomeIcon> </a></li>
                        </ul>
                        
                       
                      
                        
                    </Box>
                </Box>
            </Box>
            </div>

            
        </div>
    );
};

export default PersonalDetail;